// Originally an alternative to Babel's Map shim (needed for IE support), which turned out to be quite expensive. Also
// used in lieu of standard JS map due to a Chrome bug, which is (probably) fixed now. When we drop support for IE we
// should replace usages of this class with standard JavaScript Maps.
export class SimpleMap {
  _rootState = {};

  get (key) {
    return this._rootState[key];
  }

  set (key, value) {
    this._rootState[key] = value;
  }

  clear () {
    this._rootState = {};
  }

  get items () {
    return Object.entries(this._rootState);
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/core/SimpleMap.js